import React from "react";
import Grid from "@material-ui/core/Grid";
import Layout from "Layout";
import { Typography } from "@material-ui/core";
import Chart from "Components/Chart";
import Paper from "@material-ui/core/Paper";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import DatePickers from "Components/DatePickers";
import DateSinglePicker from "Components/DateSinglePicker";
import DateTimePicker from "Components/DateTimePicker";
import useApi from "Hooks/useApi";
import useAuth from "Hooks/useAuth";
import replaceTweetText from "fuction/replaceTweetText";
import { fromMonthly, toMonthly } from "fuction/date";
import googleAnalytics from "fuction/googleAnalytics";
import {useQueryString} from "Hooks/useQueryString";

import "dayjs/locale/ja";
import dayjs from "dayjs";

dayjs.locale("ja");

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
  tweettext: {
    whiteSpace: "pre-wrap",
  },
  count: {
    fontWeight: "bold",
  },
  graph: {
    marginTop: theme.spacing(2),
  },
  headDate: {
    marginBottom: theme.spacing(2),
  },
}));

export default function RetweetMonthly(props) {
  const { request, convertQueryParam } = useApi();
  const auth = useAuth();
  const classes = useStyles();
  const queryParams = useQueryString();

  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

  const [text, setText] = React.useState("");
  const [count, setCount] = React.useState(0);
  const [graph, setGraph] = React.useState([]);

  const fetchData = (isFirstTime = false) => {
    if (auth.state.activeGroup === 0) {
      return;
    }
    // 戻るボタンやURL直貼りで遷移してきたとき、queryParams と auth.state の activeGroup が食い違っていても、
    // 初回レンダでは state の activeGroup （デフォルトグループ）でリクエストして返されたデータで画面表示されてしまう。
    // Layout.js で queryParams と auth.state の activeGroup の同期をとったあとで走る再レンダ時のリクエストで
    // 後からデータを取得しても画面に反映されない（set○○(●●)までで再々レンダは走らない）ので、
    // 同期前で食い違いがあるうちはリクエストしない。
    const activeGroup = queryParams.get("activeGroup");
    if (activeGroup && auth.state.activeGroup !== parseInt(activeGroup, 10)) {
      return;
    }

    Promise.all([
      // グラフデータ取得API
      request({
        method: "GET",
        url: `data/:account_id/retweets/${
          auth.state.activeGroup
        }?${convertQueryParam({
          retweet: props.id,
          unit: props.unit,
          range: [props.fromDate, props.toDate],
        })}`,
      }),
      // リツイート情報取得API
      request({
        method: "GET",
        url: `data/:account_id/retweets/${
          auth.state.activeGroup
        }/statuses?${convertQueryParam({
          retweet: props.id,
          range: [props.fromDate, props.toDate],
          order: "desc",
          pagination: {
            page: "1",
            limit: "1",
          },
        })}`,
      }),
    ]).then(([graph, statuses]) => {
      setGraph(graph.data);
      setCount(statuses.meta.total_count);
    });

    if (isFirstTime) {
      // 現在日時から3か月分
      const fromDate = fromMonthly(dayjs().subtract(3, "month"));
      const toDate = toMonthly(dayjs());

      Promise.all([
        // リツイートテキスト取得
        request({
          method: "GET",
          url: `data/:account_id/retweets/${
            auth.state.activeGroup
          }/statuses?${convertQueryParam({
            retweet: props.id,
            range: [fromDate, toDate],
            order: "desc",
            pagination: {
              page: "1",
              limit: "1",
            },
          })}`,
        }),
      ]).then(([statuses]) => {
        setText(statuses.data[0]);
      });
    }
  };

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder - 話題分析";
    // 初回ツイートデータ取得
    fetchData(true);
  }, [auth.state.activeGroup]);

  React.useEffect(() => {
    googleAnalytics(window.location.pathname, auth.state.user.account_id);
  }, [window.location.pathname]);

  React.useEffect(() => {
    // フィルター変更による取得
    fetchData();
  }, [auth.state.activeGroup, props.fromDate, props.toDate]);

  const HeadDate = () => {
    if (props.target === "monthly") {
      return <DatePickers onChange={fetchData} />;
    }
    if (props.target === "daily") {
      return (
        <DateSinglePicker
          date={props.fromDate}
          onChange={(date) => props.handleChangeDateSingle(date)}
        />
      );
    }
    if (props.target === "hourly") {
      return (
        <DateTimePicker
          dateTime={props.fromDate}
          handleDateChange={props.handleDateChange}
          step={60}
        />
      );
    }
  };

  return (
    <Layout
      content={
        <Grid>
          <Grid className={classes.headDate}>
            <HeadDate />
          </Grid>
          <Grid>
            <Typography className={classes.count}>{count}件</Typography>
          </Grid>
          <Grid>
            <Paper className={classes.paper}>
              <Typography className={classes.tweettext}>
                {replaceTweetText(text)}
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} className={classes.graph}>
            <Paper className={fixedHeightPaper}>
              <Chart
                data={graph}
                dataKey={props.unit}
                onClick={(date) => props.onClickLineChart(date)}
              />
            </Paper>
          </Grid>
        </Grid>
      }
    />
  );
}
